import { render, staticRenderFns } from "./school-plans.vue?vue&type=template&id=0e4d6008&"
import script from "./school-plans.vue?vue&type=script&lang=js&"
export * from "./school-plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports